import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {OnboardingComponent} from './onboarding.component';
import {CdkStepperModule} from '@angular/cdk/stepper';
import {OnboardingButtonDirective} from './onboarding-button.directive';
import {AppBarModule} from "@app/presentation/components/app-bar/app-bar.module";

@NgModule({
  declarations: [
    OnboardingComponent,
    OnboardingButtonDirective
  ],
    imports: [
        CommonModule,
        AppBarModule
    ],
  exports: [
    OnboardingComponent,
    CdkStepperModule,
    OnboardingButtonDirective
  ]
})
export class OnboardingModule { }
